export const books = [
    {
        title: 'W raju się nie zgubisz',
        id: 'w-raju',
        url: 'http://wydawnictwoj.pl/jarek-skurzynski-w-raju-sie-nie-zgubisz/',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'wydawnictwo j',
                },
                {
                    label: 'Rok',
                    value: 'Wrocław 2024',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Redakcja',
                    value: 'Jacek Bierut',
                },
                {
                    label: 'Korekta',
                    value: 'Grzegorz Hetman',
                },
                {
                    label: 'Opracowanie graficzne',
                    value: 'Artur Skowroński',
                },
                {
                    label: 'ISBN',
                    value: '978-83-969298-7-7',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'wydawnictwo j',
                },
                {
                    label: 'Year',
                    value: 'Wrocław 2024',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Editor',
                    value: 'Jacek Bierut',
                },
                {
                    label: 'Proofreading',
                    value: 'Grzegorz Hetman',
                },
                {
                    label: 'Book design',
                    value: 'Artur Skowroński',
                },
                {
                    label: 'ISBN',
                    value: '978-83-969298-7-7',
                },
            ],
        },
        isQuoteStyled: true,
        quote: [
            {
                style: { fontSize: '1.2rem', paddingBottom: '2rem' },
                content: [
                    { style: {}, text: '(lecą żurawie, może co inne, może gęsi to, nie wiadomo, coś leci, patrzymy, ale słońce świeci, mrużymy oczy, nic nie widzimy, ciepło)' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'a gdzie postawisz [rękopis nieczytelny]' },
                ]
            },
            {
                style: { fontSize: '0.8rem', fontStyle: 'italic', marginInline: '5rem', marginBlock: '2rem' },
                content: [
                    { style: {}, text: '—mimo usilnych starań nie byłem w stanie przeczytać w rękopisie, o jakim przedmiocie bohater mówi, litery zostały zamazane, coś się na ten fragment autorowi wylało—' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: { textDecoration: 'line-through' }, text: 'o' },
                    { style: {}, text: ' tam ' },
                    { style: { textDecoration: 'line-through' }, text: 'blisko nie za daleko' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'zmarnuje się' },
                ]
            },
            {
                style: { textAlign: 'center' },
                content: [
                    { style: {}, text: 'wszystko dzisiaj takie jak' },
                ]
            },
            {
                style: { paddingLeft: '54%' },
                content: [
                    { style: {}, text: 'z papieru' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'jak buty z tektury' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'trupięgi kiedyś' },
                ]
            },
            {
                style: { textAlign: 'center' },
                content: [
                    { style: {}, text: 'teraz to muszą być najdroższe' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'najlepsze' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'bo wygodne' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'muszą być' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'yć' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'powinny być ciepłe' },
                ]
            },
            {
                style: { textAlign: 'right' },
                content: [
                    { style: {}, text: 'i przewiewne' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'i lekkie' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: { paddingLeft: '10%' }, text: 'takie' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: { paddingLeft: '20%' }, text: 'akurat' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: { paddingLeft: '30%' }, text: 'do' },
                ]
            },
            {
                style: { textAlign: 'center' },
                content: [
                    { style: {}, text: 'przechodzenia' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'i do sklepu' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: {}, text: 'i po górach' },
                ]
            },
            {
                style: { textAlign: 'left' },
                content: [
                    { style: { paddingLeft: '30%' }, text: 'wygodnie' },
                ]
            },
            {
                style: { textAlign: 'center' },
                content: [
                    { style: {}, text: 'ale nie do trumny' },
                ]
            },
            {
                style: { fontSize: '1.2rem', paddingTop: '2rem' },
                content: [
                    { style: {}, text: '(ktoś się pojawia, ale nikt nie wie kto, bo za jasno na widzenie)' },
                ]
            },
        ],
    },
    {
        title: 'Zły syn',
        id: 'zly-syn',
        url: 'https://wydawnictwo.artrage.pl/products/zly-syn',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'ArtRage',
                },
                {
                    label: 'Rok',
                    value: 'Warszawa 2024',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Redakcja',
                    value: 'Urszula Obara',
                },
                {
                    label: 'Korekta',
                    value: 'Michał Trusewicz, Aleksandra Marczuk-Radoszek',
                },
                {
                    label: 'Projekt okładki i projekt typograficzny',
                    value: 'Mimi Wasilewska',
                },
                {
                    label: 'ISBN',
                    value: '978-83-67515-74-0',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'ArtRage',
                },
                {
                    label: 'Year',
                    value: 'Warsaw 2024',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Editor',
                    value: 'Urszula Obara',
                },
                {
                    label: 'Proofreading',
                    value: 'Michał Trusewicz, Aleksandra Marczuk-Radoszek',
                },
                {
                    label: 'Cover design and typography',
                    value: 'Mimi Wasilewska',
                },
                {
                    label: 'ISBN',
                    value: '978-83-67515-74-0',
                },
            ],
        },
        isQuoteStyled: false,
        quote: [
            'Mówiono o mnie, że jestem zdolny, ale leniwy. To „ale” wybrzmiewało mi w głowie przez wiele lat. Nie wiedziałem, dlaczego tak mówią. Nie byłem leniwy. Czasami nie wychodziło mi coś tak, jak tego chciałem.',
            '\tPowtarzali wciąż: zdolny, ale leniwy. Jakby miało mnie to czegokolwiek nauczyć. Zdolny, ale leniwy. Powtarzały nauczycielki, ciotki, kuzyni, wujkowie, sąsiedzi. Matka też to powtarzała. Aż w końcu sam w to uwierzyłem. Nauczyłem się nawet tego nie słyszeć.',
            '\tNie chodziło jednak o to, żeby nie słyszeć. Chciałem zrozumieć, dlaczego tak mówią. Dlaczego to „ale” jest takie dla nich ważne?',
            '\tCzy mówili to specjalnie, żeby do czegoś mnie zmusić? Nie rozumiałem.',
            '\tByłem zdolny, ale...',
            '\tTo jestem zdolny czy nie? Istnieje jakiś warunek tej mojej zdolności? Dlaczego innych nazywano po prostu zdolnymi, pomimo że też nie zawsze wszystko im wychodziło? Nawet wtedy chwalono ich bezwarunkowo. Nie mówiono im nawet, że następnym razem poprawią.',
            '\tMatka mi powtarzała: następnym razem się postarasz. To znaczy, że tym razem się nie starałem?',
            '\tI dodawała, że muszę być grzeczny.',
            '\tNie jestem grzeczny?',
            '\tCo jest ze mną nie tak, że ciągle mi się to mówi? W żadnym momencie swojego życia nie byłem dla nikogo wystarczająco zdolny. A później ona zmarła i zostawiła mnie z całym tym gównem.',
        ],
    },
    {
        title: 'Lakier',
        id: 'lakier',
        url: 'https://wydawnictwo-granda.pl/produkt/lakier/',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'Wydawnictwo Granda',
                },
                {
                    label: 'Rok',
                    value: 'Szczecin 2022',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Redakcja',
                    value: 'Sylwia Głuszak',
                },
                {
                    label: 'Korekta',
                    value: 'Katarzyna Dubois',
                },
                {
                    label: 'Projekt okładki i projekt typograficzny',
                    value: 'Mimi Wasilewska',
                },
                {
                    label: 'ISBN',
                    value: '978-83-964649-9-6',
                },
                {
                    label: 'Wyróżnienia',
                    value: 'Nominacja do Nagrody Literackiej „Jantar”',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'Wydawnictwo Granda',
                },
                {
                    label: 'Year',
                    value: 'Szczecin 2022',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Editor',
                    value: 'Sylwia Głuszak',
                },
                {
                    label: 'Proofreading',
                    value: 'Katarzyna Dubois',
                },
                {
                    label: 'Cover design and typography',
                    value: 'Mimi Wasilewska',
                },
                {
                    label: 'ISBN',
                    value: '978-83-964649-9-6',
                },
                {
                    label: 'Distinctions',
                    value: 'Shortlisted for the „Jantar” Literary Prize',
                },
            ],
        },
        isQuoteStyled: false,
        quote: [
            'Wyleciało mu z głowy imię kumpla, z którym pił właśnie piwo. Poznali się po wojnie. Stach szperał w piwnicach, ganiał po strychach i chował po kieszeniach wszystko, co wydało mu się wartościowe. Za przyzwoleniem ojca, ale w tajemnicy przed matką. Przemykał, żeby nikt go nie dostrzegł, wiadomo. Nie zliczy, ile to razy uciekał milicji. Ha! Ale ani razu go nie złapali. Taki był! Zwinny jak węgorz!',
            '\tCzasami słyszał strzały, ale on strzelania się nie bał. Brat ojca – wujek Waldek – opowiadał Stachowi, że w czasie wojny poszedł w las. To znaczy do partyzantki, ale na wsi mówili, że idą w las. Pokazał mu mauzera. Mówił, że ukatrupił Niemca i mu zabrał. Ale Stach już nie pamięta, jak wujek Waldek wyglądał. Na pewno miał ciemne włosy. Jak ojciec Stacha. Nic więcej nie mógł sobie przypomnieć.',
            '\tW ogóle jakoś ostatnio zapominał twarze. Uciekały mu z pamięci. Mamusi też nie za bardzo może sobie przypomnieć. Co za licho!? Pamięta kolor włosów i że była wysoka, ale nie może sobie przypomnieć twarzy. Musi poszukać zdjęć. Ale czy rozpozna ją na tych fotografiach? A jeśli nie? Nagle wszystko do niego wróciło – mamusia stanęła przed nim jak żywa. I rozpoznał ją. Jak mógłby nie rozpoznać? Ale wujka Waldka to już sobie chyba łatwo nie przypomni.',
            '\tWujek Waldek, ojciec Albert, matka Franciszka, siostra Basia, druga siostra Gienia, brat Jan, babka Stefania, dziadek Andrzej.',
            '\tFranek!',
            '\tTak, Franek!',
            '\tWbiegł do piwnicy sąsiedniej kamienicy. Może znajdzie tu jakieś skarby! Chodził od pomieszczenia do pomieszczania. Było ciemno, śmierdziało wilgocią i co chwila potykał się o leżące cegły albo wpadał na jakieś deski. W jednym z pomieszczeń, do którego światło wpadało przez brudne okno, stała zmurszała szafa. Ucieszył się, że może coś w niej znajdzie. Usłyszał dobiegający z niej chrobot. Może to szczury? Już chciał się wycofać, bo matka go straszyła, że szczury skaczą do szyi i zagryzają małe dzieci. Ktoś kichnął. Podkradł się do drzwi, szarpnął. W środku siedział skulony chłopak. To był Franek.',
            '\n',
            '– Stach! – Krycha wychyliła się przez okno. – Obiad!',
            '\tZłapał za klamkę do mieszkania, ale było zamknięte. Stara wariatka zamyka mi drzwi, jak woła na obiad. Zbzikowała do reszty! Szarpnął jeszcze kilka razy i zaczął walić pięścią w drzwi. Poczuł nagły przypływ złości. Usłyszał zgrzyt zamka i już miał się wydrzeć, kiedy w drzwiach pojawił się sąsiad.',
            '\t– A ty Stach co mi się do domu dobijasz? – zapytał sąsiad.',
            '\tStach oniemiał.',
            '\t– Napiłeś się?',
            '\tStach potrząsnął głową i burknął, że pomylił drzwi. Poczłapał na swoje piętro. Drzwi były otwarte. Wszedł i poczuł zapach mielonych.',
            '\tAle te kotlety jakoś przestały mu smakować. Czy olej inny, czy mięso, czy co?',
            '\t– Co te kotlety jakieś takie inne? – zapytał wkurzony Stach.',
            '\t– Jakie inne?! Normalne, jak zawsze – odpowiedziała Krysia.',
            '\t– No inne, przecież czuję, że inne. Co powydziwiałaś?! – warknął.',
            '\t– Nic nie powydziwiałam! Normalne przecież!',
        ],
    },
    {
        title: 'Jedenaście medytacji nad istnieniem dzieła sztuki',
        id: 'jedenascie-medytacji',
        url: 'http://wnkatedra.pl/pl/p/Jedenascie-medytacji-nad-istnieniem-dziela-sztuki-Jarek-Skurzynski/22522622',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'Wydawnictwo Naukowe Katedra',
                },
                {
                    label: 'Rok',
                    value: 'Gdańsk 2021',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Projekt okładki',
                    value: 'Anna M. Damasiewicz',
                },
                {
                    label: 'Skład',
                    value: 'Dariusz Piskulak',
                },
                {
                    label: 'Ilustracje',
                    value: 'Daniel Pański, Kuba Klimek',
                },
                {
                    label: 'ISBN',
                    value: '978-83-66107-45-8',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'Wydawnictwo Naukowe Katedra',
                },
                {
                    label: 'Year',
                    value: 'Gdańsk 2021',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Cover design',
                    value: 'Anna M. Damasiewicz',
                },
                {
                    label: 'Typesetting',
                    value: 'Dariusz Piskulak',
                },
                {
                    label: 'Illustrations',
                    value: 'Daniel Pański, Kuba Klimek',
                },
                {
                    label: 'ISBN',
                    value: '978-83-66107-45-8',
                },
            ],
        },
        isQuoteStyled: false,
        quote: [
            'Spoglądam na obrazy Rashida Rana (Pakistan). W każdym z nich widzę jeden obraz, ale każdy z nich jest złożony z nieprzeliczalnej ilości małych zdjęć. To nie zwraca uwagi tylko na prosty fakt, że całość zawsze złożona jest z wielości, ale przede wszystkim podkreśla istotę współczesnego świata (odbierania współczesnego świata?): żyjemy w wieloświecie, który w nieodgadniony sposób stanowi – jeszcze – całość. Współczesna sztuka ma głęboką świadomość kruchej tkanki, z jakiej utkany jest dzisiejszy świat: zanegowanie, zniszczenie czy unicestwienie chociażby najmniejszego konstytuującego go elementu może spowodować rozpad całości. Prawdopodobnie nic na to nie poradzimy, ta całość w końcu się kiedyś rozpadnie. Nie wiemy też, czy to stanie się po zniszczeniu jednego elementu, dziesięciu czy stu. Nie znamy granicy. Nie wiemy, gdzie ona jest. Wiemy jedynie, że ta granica gdzieś istnieje. Ponownie mam nieodparte wrażenie, że sztuka konfrontuje nas z tym, co nie istnieje (albo z tym, co może przestać istnieć).',
            '\tObserwuję obraz „Body (Mom) No. 8” Uttapoma Nimmalaikaewa (Tajlandia): postać matki rozmywa się w charakterystyczny sposób – spływa z materii, jaką jest płótno. Obserwuję nie tylko upływ czasu, ale także strach przed nieistnieniem. Jeśli jednak przyjrzymy się dokładnie, wejrzymy za ten czas, spojrzymy za postać matki rzuconej w czas i przestrzeń, to zobaczymy, że cień matki nie podlega już tym samym prawom, co jej ciało. Cień, przedstawiający sylwetkę matki, pozostał nienaruszony.',
            '\tRana i Nimmalaikaew zdają się pokazywać dwa różne rozumienia rozpadu, dwie różne koncepcje całości i może dwie różne koncepcje istnienia sztuki. Na pewno obydwoje konfrontują nas z nieistnieniem, z rozpadem i ideą całości. Interesująca jest tutaj koncepcja całości: u pierwszego całość wysuwa się na pierwszy plan, u drugiego – idea całości jest ukryta, trzeba się do niej dostać. U Rana całość jest od razu widoczna, oto mamy przed sobą całość, nie musimy się wysilać, aby ją dostrzec, w mgnieniu oka ją rozpoznajemy. U Nimmalaikaewa całość jest czymś, czego musimy się domyślić, co musimy zinterpretować, dodać do upływającego czasu i rozpadającej się materii, musimy sobie uświadomić, że skoro materia się rozpada, to w jakiś sposób była/jest całością.',
            '\tRana zdaje się mówić, że to złożoność jest czymś, co musimy zobaczyć, natomiast dla Nimmalaikaewa to złożoność i wielość, wyrażona w upływie czasu i rozpadzie materii, wydaje się dostępna bez żadnej refleksji. U Rana mamy fragmentaryczny świat, na który nakładamy ideę całości. Idea całości jednak wymusza na nas do- świadczenie złożoności. I wtedy dopiero dowiadujemy się o kruchości tej całości, że ten wieloświat działa, ale w nieznany dla nas sposób. To jakieś procesy, których zakłócenie może spowodować rozpad całości, nastąpi chaos (który Rana zdaje się pokazywać na innych swoich obrazach), pomieszanie elementów, z których już nie będzie nam tak łatwo domyślić się całości. Nimmalaikaew chyba podpowiada nam, że idea wielości jest nam dostępna przez doświadczenie, chaosu wcale nie musimy zakładać, my go obserwujemy, przemijanie i rozpad wpisane są w naszą istotę bycia śmiertelnym. To właśnie całość jest czymś, co trudno nam zobaczyć, majaczy ona niby cień, gdzieś w oddali. Może nawet nie wiemy, co z tym cieniem mamy tak naprawdę zrobić. Przecież cień traktujemy jako coś pochodnego, nie jest istnieniem per se.',
            '\tNasze podejście do idei całości będzie rzutować na osobiste doświadczanie sztuki. W ukrytej idei całości będziemy widzieć jej powolny rozkład, jej powolne, ale nieuchronne zanikanie. Natomiast całość, scalająca poszczególne fragmenty, będzie nas prowadzić do raczej odmiennego wniosku: istnienie sztuki nigdy nie będzie podważone, zawsze bowiem będzie istniała jakaś metafizyczna czy rzeczywista wielość i zawsze będziemy próbowali zobaczyć jej całość. To pragnienie czysto metafizyczne: ujrzenie całości. A pragnień trudno się wyzbyć i często trudno je zaspokoić. Tym właśnie jest pragnienie.',
            '\tWydaje się, że sztuka istnieje na granicach całości i wielości. Idee całości i wielości jednak nawzajem się wypełniają. Jedna bez drugiej nie może istnieć. Jedna bez drugiej nie mogłaby nigdy zaistnieć. Zdaje się, że sztuka sama sobie zadaje śmierć wtedy, kiedy próbuje zaistnieć tylko w obrębie jednej z nich.',
        ],
    },
    {
        title: 'Zrolowany wrześniowy Vogue',
        id: 'zrolowany-wrzesniowy-vogue',
        url: 'https://www.sklep.ha.art.pl/pl/p/Zrolowany-wrzesniowy-Vogue-Jarek-Skurzynski/512',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'Korporacja ha!art',
                },
                {
                    label: 'Rok',
                    value: 'Kraków 2020',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Redakcja',
                    value: 'Marta Syrwid',
                },
                {
                    label: 'Redakcja serii',
                    value: 'Piotr Marecki',
                },
                {
                    label: 'Projekt okładki',
                    value: 'Bolesław Chromry',
                },
                {
                    label: 'Projekt typograficzny, skład i łamanie',
                    value: 'By Mouse',
                },
                {
                    label: 'ISBN',
                    value: '978-83-66571-00-6',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'Korporacja ha!art',
                },
                {
                    label: 'Year',
                    value: 'Cracov 2020',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Editor',
                    value: 'Marta Syrwid',
                },
                {
                    label: 'Series editor',
                    value: 'Piotr Marecki',
                },
                {
                    label: 'Cover design',
                    value: 'Bolesław Chromry',
                },
                {
                    label: 'Typography and typesetting',
                    value: 'By Mouse',
                },
                {
                    label: 'ISBN',
                    value: '978-83-66571-00-6',
                },
            ],
        },
        isQuoteStyled: false,
        quote: [
            'Miasto pięknie się budzi. Słońce ogrzewa mi twarz, przebijając spomiędzy budynków. Widzę się w oknie wystawowym i stwierdzam, że jak na tak pospieszną ewakuację z mieszkania Chybaphila, to wyglądam nieźle.',
            '\tW kawiarni zamawiam kawę i sernik czekoladowy, który nie dość, że jest nieprzyzwoicie dobry, to jeszcze podał mi go facet o anielskiej urodzie.',
            '\tAle.',
            '\tZdążyłem zauważyć, że ma brud za paznokciami. Jeśli więc przedtem dałbym mu 9 punktów na 10 (ciekawe, ile on by mi dał?), to po tym spada o 5, co daje mu 4 punkty.',
            '\tAle.',
            '\tWedług praesumptio boni viri muszę uznać go za niewinnego. Prawdopodobne jest przecież, że chłopiec jest bez winy, bo ma taką, a nie inną pracę — a zatem brud niekoniecznie wynika z zaniedbywania higieny w ogóle. Pewnie uświnił sobie pazury jakimiś kawałkami ciasta, kawą (a kawa uwielbia przecież wchodzić pod paznokcie i nie daje się tak łatwo wyszczotkować) czy czymkolwiek innym. Ponownie daję mu więc 9 punktów.',
            '\tAle.',
            '\tTe 9 punktów nie zmienia faktu, że jest flejtuchem, więc odejmuję mu jednak 3. Ma teraz 6 punktów, co, nie ukrywam, trochę mnie boli, bo niedawno tyle samo dałem przypadkowemu przechodniowi, który nawet na mnie nie rzucił okiem, a ten tu podaje mi kawę i ładnie się uśmiecha. Nie może mieć tyle samo punktów co byle przechodzień. Podwyższam więc o 2. Ma 8. Analizuję ponownie moje oskarżenie o flejostwo i muszę przyznać, że bardzo surowo go oceniłem. Bo czyż sam za każdym razem w pracy ganiam umyć dłonie, kiedy widzę na nich drobną skazę czy zabrudzenie? Raczej nie, a fleją siebie bym nie nazwał. Prawdopodobnie chłopak się̨ ubrudził, zerknął na dłonie, westchnął z rezygnacją i już miał iść je umyć, ale zobaczył, że są nowi klienci (ja!), podbiegł, żeby mnie obsłużyć i przez to nie wyszorował paznokci. Daję mu punkt więcej i pozostawiam na mojej liście z końcowym wynikiem 9 punktów, za co siebie i jego nagradzam uśmiechem. Dorzucam też napiwek, żeby nie było, że ja jestem tylko ładny i oprócz tego nic nie daję, bo myślę, że uroda wystarczy. Odwzajemnia uśmiech, przetrzymuje spojrzenie, mruga, pyta: „Czy coś jeszcze?”, a ja mu na to, że: „Nic więcej, dziękuję”. Zabieram z lady swoje zabawki, prawie się potykam, siadam przy najbliższym stoliku, abym jeszcze mógł spojrzeć na tę moją dziewiątkę̨, o którą sam ze sobą stoczyłem tak żarliwy bój.',
            '\tZa oknem momentalnie pociemniało i lunął deszcz. Na kałużach pęcznieją potężne bąble. Do kawiarni wbiega kobieta i przez otwarte drzwi bucha poranny oddech miasta, w którym świeżo skoszona trawa wymieszała się z wonią mokrego asfaltu, wymiocin, cegły, ziemi i moczu. Postanawiam przeczekać ulewę, jestem przekonany, że za pół godziny ponownie wyjdzie słońce.',
            '\tKątem oka zauważam zbliżającą się do stolika dziewiątkę.',
        ],
    },
    {
        title: 'Tylko ateiści zostaną zbawieni',
        id: 'tylko-ateisci-zostana-zbawieni',
        url: '',
        details: {
            PL: [
                {
                    label: 'Wydawca',
                    value: 'Instytut Wydawniczy „Książka i Prasa”',
                },
                {
                    label: 'Rok',
                    value: 'Warszawa 2015',
                },
                {
                    label: 'Wydanie',
                    value: 'pierwsze',
                },
                {
                    label: 'Wstęp',
                    value: 'Justyna Wodzik',
                },
                {
                    label: 'Grafika na okładce',
                    value: 'Marcin Zgrzywa',
                },
                {
                    label: 'Skład i łamanie',
                    value: 'Anna Lewandowska',
                },
                {
                    label: 'ISBN',
                    value: '879-83-62744-67-1',
                },
            ],
            EN: [
                {
                    label: 'Publisher',
                    value: 'Instytut Wydawniczy „Książka i Prasa”',
                },
                {
                    label: 'Year',
                    value: 'Warsaw 2015',
                },
                {
                    label: 'Edition',
                    value: '1st',
                },
                {
                    label: 'Introduction',
                    value: 'Justyna Wodzik',
                },
                {
                    label: 'Cover illustration',
                    value: 'Marcin Zgrzywa',
                },
                {
                    label: 'Typesetting',
                    value: 'Anna Lewandowska',
                },
                {
                    label: 'ISBN',
                    value: '879-83-62744-67-1',
                },
            ],
        },
        isQuoteStyled: false,
        quote: [
            'Kapłani wyznania chrześcijańskiego bardzo sprytnie zaszczepili w swoich wyznawcach przekonanie, że religia chrześcijańska jest fundamentem tradycji zachodnioeuropejskiej. Pomijam fakt, że to tradycja grecka i rzymska stworzyła cywilizację Zachodu, a dopiero później nadeszła cywilizacja chrześcijańska. Tkwi jednak w nas – w ludziach Zachodu niepodważalne przekonanie, że to chrześcijaństwo zbudowało całą cywilizację Europy. Nie wytykamy jednak chrześcijaństwu każdego trupa, na ciele którego stawały olbrzymie katedry w każdym europejskim kraju; nie wytykamy tego, że na wiele wieków wstrzymało rozwój nauki i techniki; nie wytykamy na każdym kroku podejrzanych moralnie decyzji co do obierania stron w konfliktach zbrojnych państw Europy. Chrześcijaństwo zaszczepiło w nas też przekonanie, że odejście od „tradycji ojców” spowoduje rozpad społeczeństwa, upadek obyczajów, moralne zepsucie itd. Wygląda na to, że tylko chrześcijanie mogą stać na straży ludzkiej moralności i obyczajności. W Polsce natomiast zapewnia się, że pod władzami Kościoła wyznania rzymskokatolickiego będzie kwitła gospodarka i ekonomia, a każde państwo pod jego rządami będzie najszczęśliwszym państwem pod słońcem i żadne kryzysy nie będą mu straszne. Wiele razy słyszałem z ust osób wierzących i księży, że źródłem obecnego kryzysy ekonomiczno-gospodarczego jest popełnianie siedmiu grzechów głównych (chodzi chyba zwłaszcza o grzechy pychy i chciwości). Łatwo zobaczyć absurd rozumowania: na świecie jest źle, bo ludzie nie przestrzegają przykazań, grzeszą i oddalają się od kościoła. Dlaczego ludzie grzeszą i oddalają się od kościoła? Bo istnieje kryzys wartości. A dlaczego istnieje kryzys wartości? Bo ludzie odchodzą od wiary chrześcijańskiej, a skoro odchodzą od przestrzegania pewnych wartości to wszystkie wymiary życia człowieka przestają funkcjonować poprawnie. I w taki sposób wszystkie dziedziny życia można tłumaczyć życiem religijnym i przekonaniami religijnymi. Czy naprawdę bóg posiada niezaspokojoną potrzebę bezlitosnego umartwiania człowieka na każdym jego kroku i w każdej możliwej dziedzinie jego życia? Aż dziw, że bóg do tej pory nie zesłał na człowieka Armagedonu za to, że naukowcy zaczęli rozbijać atom i obserwować najmniejsze elementy rzeczywistości. Dlaczego tu kościół nie zada pytania o przestrzeganie wartości religijnych?',
            '\tTłumaczenie wszystkiego za pomocą przekonań religijnych i świata mitycznego powoduje, że świadomość tradycji danej religii wzmaga opór wielu ludzi przed jej negowaniem, bo obawiają się, że kolejnym krokiem będzie likwidacja dziedzictwa tej religii. Nikt nie chce tego czynić, nikt nie zaneguje 2 tys. lat tradycji chrześcijańskiej w Europie. Nie ma ku temu żadnej potrzeby, pomimo że tradycja ta posiada obok dobrych, bardzo ciemne i krwawe miejsca na ciele tej tzw. tradycji ojców. Zaprzeczanie temu, równałoby się z brakiem wiedzy i świadomości historycznej. Tradycja chrześcijańska jednak nie ma już dzisiejszym czasom niczego (a jeśli ma to w bardzo znikomym stopniu) do zaoferowania. Jej mityczna wizja wszechświata przestała być interesująca wraz z pierwszymi odkryciami naukowymi na polu astronomii. Każda tradycja przemija, taka jest kolej rzeczy, przechodzi do muzeum, odnosimy się do niej z szacunkiem tak, jak odnosimy się z szacunkiem do maski pośmiertnej Tutenchamona. Trzymanie się kurczowo przekonań tej tradycji spowodowałoby tylko intelektualne cofnięcie się do czasów, kiedy powstanie świata nie było przedmiotem naukowej debaty, a literackich sporów na temat tego, co o tym napisano tylko w jednej księdze. Wartości tradycji chrześcijańskiej zostaną przemyślane na nowo, wszystkie te, które przyczyniają się do wzrostu agresji i w żadnym stopniu nie przyczyniają do poprawy życia – zostaną słusznie odrzucone. Wartości mają być ramą działań człowieka, żadna jednak z tych ram nie może powodować zatrzymania rozwoju ludzkości, wtedy takie wartości stają się więzieniem, w którym powstaje coraz to bardziej wysublimowany (a przez to niezrozumiały) system kar. Takim więzieniem dla ludzkości zaczyna być tradycja chrześcijańska. Brak umiejętności odczytywania wartości na nowo jest ewidentnym brakiem szacunku dla człowieka i wciskanie go w niepotrzebny gorset przekonań, które z dzisiejszym światem i z dzisiejszym rozumieniem świata nie mają nic wspólnego.',
        ],
    },
];
